import axios from 'axios';

import { getUserData, QUERYAPI } from '../constants/global';
import type { CreateSituationReportOutcome, ICreateSituationReport } from '../interface/child-agent';

// Standalone client for filing a situation report. Same isolation pattern as the
// other coverage-drawer libs: attaches the core JWT + PartyId, reads non-2xx
// bodies (validateStatus), and has NO 401->logout interceptor so a reports-service
// hiccup can never sign the agent out mid-flow.
const situationApi = axios.create({ baseURL: QUERYAPI });

situationApi.interceptors.request.use((config) => {
	const { token, user } = getUserData();
	if (token) config.headers.Authorization = `Bearer ${token}`;
	if (user?.PartyId) config.headers.PartyId = user.PartyId;
	return config;
});

export const createSituationReport = async (payload: ICreateSituationReport): Promise<CreateSituationReportOutcome> => {
	try {
		const res = await situationApi.post('/api/v1/citizens-agent/Result/create-situation-report', payload, {
			validateStatus: () => true,
		});
		const body = typeof res.data === 'string' ? null : (res.data?.data ?? res.data ?? null);
		return { reachable: true, httpStatus: res.status, body };
	} catch {
		return { reachable: false };
	}
};
